import { render } from "./editAppSettings.vue?vue&type=template&id=3365ae82&scoped=true"
import script from "./editAppSettings.vue?vue&type=script&lang=js"
export * from "./editAppSettings.vue?vue&type=script&lang=js"

import "./editAppSettings.vue?vue&type=style&index=0&id=3365ae82&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3365ae82"]])

export default __exports__